import { HttpErrorResponse } from '@angular/common/http';
import { UserIdentification, UsersId } from '@models/swagger';
import { createAction, props } from '@ngrx/store';
import { UsersIdParams } from './service';

export enum UsersIdActions {
  Failure = '[Application Utilities UsersId] Failure',
  Request = '[Application Utilities UsersId] Request',
  Success = '[Application Utilities UsersId] Success',
  Reset = '[Application Utilities UsersId] Reset',
}

export const UsersIdFailure = createAction(UsersIdActions.Failure, props<{ error: HttpErrorResponse }>());

export const UsersIdRequest = createAction(
  UsersIdActions.Request,
  props<{ body: UsersId; parameters?: UsersIdParams }>()
);

export const UsersIdSuccess = createAction(UsersIdActions.Success, props<{ data: UserIdentification }>());

export const UsersIdReset = createAction(UsersIdActions.Reset);
